export type TIMEZONE_KEY = string;

export enum SuiteId {
    PLATFORM = 0,
    APP_BUILDER = 1,
    ANALYTICS = 99,
    KMS = 103,
    GOVERNANCE = 104,
    SALES = 105,
    WUFAN = 107
}

export interface IFile {
    _id: string;
    bucket?: string;
    downloadUrl: string;
    mime: string;
    name: string;
    previewUrl?: string;
    qnKey?: string;
    ossKey?: string;
    size: number;
    thumbUrl?: string;
    uploadTime: string;
    uploader: string;
    url: string;
}
